/**
 * `Inline` is a caption-sized disclosure that sits inside content (a chat answer's "what I did" line).
 * `Eyebrow` is a full-width header set in the house uppercase label, for a group inside a settings column
 * whose other groups are headed by that label — a `Section` title there would outrank them.
 * `Card` is a raised card whose header carries a leading round icon and trailing meta — one group in a stack of
 * groups (a send batch and the people in it).
 * `Disclosure` is a card-sized row on its own surface, for the ONE control that opens a page's supporting detail under
 * a conclusion — a `Section` header there reads as a settings group heading and gets skipped.
 */
export enum CollapsibleSectionVariant {
	Section = "section",
	Inline = "inline",
	Eyebrow = "eyebrow",
	Card = "card",
	Disclosure = "disclosure",
}
